import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { Investment_RiskLevel as RiskLevel } from 'types/common';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import RiskIcon from 'components/RiskIcon';

import './index.scss';

interface Props {
  shapedIcons?: boolean;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('idea-card-risk-legend');

const enhance = compose<Enhanced, Props>(translate);

class RiskLegend extends React.Component<Enhanced> {
  render() {
    const { t, shapedIcons } = this.props;

    return (
      <table className={b()} cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <th className={b('title')} colSpan={2}>
              {t('Risk level')}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span className={b('icon')}>
                <RiskIcon shaped={shapedIcons} level={'LOW'} filled />
              </span>
              {t(RiskLevel.LOW)}
            </td>
            <td className="text_right">{t('To')} 10%</td>
          </tr>
          <tr>
            <td>
              <span className={b('icon')}>
                <RiskIcon shaped={shapedIcons} level={'MEDIUM'} filled />
              </span>
              {t(RiskLevel.MEDIUM)}
            </td>
            <td className="text_right">10-30%</td>
          </tr>
          <tr>
            <td>
              <span className={b('icon')}>
                <RiskIcon shaped={shapedIcons} level={'HIGH'} filled />
              </span>
              {t(RiskLevel.HIGH)}
            </td>
            <td className="text_right">{t('More than')} 30%</td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default enhance(RiskLegend);
